function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import React from 'react';
import DropTarget from '@uppy/drop-target';
import ReactDomAdapter from '../ReactDomAdapter';
import Logger from '../Logger';
import UiMutator from '../UiMutator';
import { UploaderModal, ImageEditorModal, UppyClient, ProviderConfig } from '../components';
/**
 * KjUploader core
 * Intended to be a drop-in replacement for App.FilepickerUpload in the monolith.
 *
 * Ideally this can be used in the following ways:
 * - Within a useKjUploader hook that is distributed by this package
 * - Within KjUploaderComponent via useKjUploader hook
 * - As a drop-in replacement for App.Filepicker
 *
 * This structure allows us to centralize the uploader logic in 1 location
 * rather than having multiple implementations of interacting with the service.
 * (Hence the 'Core' naming of this class.)
 *
 * This class would ReactDOM-mount a React component to a provided DOM node
 * provided within the config.
 *
 */

var MOUNT_NODE_ID = 'kj-uploader';

var _componentProps = /*#__PURE__*/_classPrivateFieldLooseKey("componentProps");

var _mountNode = /*#__PURE__*/_classPrivateFieldLooseKey("mountNode");

var _createMountNode = /*#__PURE__*/_classPrivateFieldLooseKey("createMountNode");

var _mountImageEditorModal = /*#__PURE__*/_classPrivateFieldLooseKey("mountImageEditorModal");

var KjUploader = /*#__PURE__*/function () {
  function KjUploader(config) {
    _classCallCheck(this, KjUploader);

    Object.defineProperty(this, _mountImageEditorModal, {
      value: _mountImageEditorModal2
    });
    Object.defineProperty(this, _createMountNode, {
      value: _createMountNode2
    });
    Object.defineProperty(this, _mountNode, {
      value: _mountNode2
    });
    Object.defineProperty(this, _componentProps, {
      value: _componentProps2
    });
    // TODO: Argument check `config`
    this.config = config;
    this.logger = new Logger({
      datadogClientToken: this.config.datadogClientToken,
      context: this.config.loggerContext,
      enableConsole: this.config.debug
    });
    this.uiMutator = new UiMutator({
      el: _classPrivateFieldLooseBase(this, _mountNode)[_mountNode](),
      config: config
    });
    this.logger.debug('new KjUploader', this.config);
    this.dndUppyClient = null;
  }

  _createClass(KjUploader, [{
    key: "open",
    value: function open() {
      var _this$config$onOpen, _this$config;

      ReactDomAdapter.render( /*#__PURE__*/React.createElement(UploaderModal, _classPrivateFieldLooseBase(this, _componentProps)[_componentProps]()), _classPrivateFieldLooseBase(this, _mountNode)[_mountNode]());
      this.logger.debug('open');
      this.uiMutator.observe();
      (_this$config$onOpen = (_this$config = this.config).onOpen) === null || _this$config$onOpen === void 0 ? void 0 : _this$config$onOpen.call(_this$config);
    }
  }, {
    key: "close",
    value: function close() {
      var _this$config$onClose, _this$config2;

      this.uiMutator.disconnect();
      ReactDomAdapter.unmount(_classPrivateFieldLooseBase(this, _mountNode)[_mountNode]());
      this.logger.debug('close');
      (_this$config$onClose = (_this$config2 = this.config).onClose) === null || _this$config$onClose === void 0 ? void 0 : _this$config$onClose.call(_this$config2);
    }
  }, {
    key: "storeUrl",
    value: function storeUrl(url) {
      var _this = this;

      var options = _objectSpread(_objectSpread({}, _classPrivateFieldLooseBase(this, _componentProps)[_componentProps]()), {}, {
        maxFiles: 1,
        autoProceed: false,
        sources: ['Url']
      });

      var uppy = UppyClient(options, ProviderConfig(options).plugins);
      uppy.on('file-added', function (file) {
        var _imageEditor$canEditF;

        var imageEditor = uppy.getPlugin('ImageEditor');

        if (options.autoOpenFileEditor && imageEditor !== null && imageEditor !== void 0 && (_imageEditor$canEditF = imageEditor.canEditFile) !== null && _imageEditor$canEditF !== void 0 && _imageEditor$canEditF.call(imageEditor, file)) {
          _classPrivateFieldLooseBase(_this, _mountImageEditorModal)[_mountImageEditorModal]({
            uppy: uppy,
            file: file,
            options: options
          });
        } else {
          uppy.upload();
        }
      });
      uppy.getPlugin('Url').addFile(url);
    }
  }, {
    key: "makeDropPane",
    value: function makeDropPane(_ref) {
      var target = _ref.target,
          onDragOver = _ref.onDragOver,
          onDrop = _ref.onDrop,
          onDragLeave = _ref.onDragLeave;

      var options = _objectSpread(_objectSpread({}, _classPrivateFieldLooseBase(this, _componentProps)[_componentProps]()), {}, {
        autoProceed: true,
        autoOpenFileEditor: false,
        sources: []
      });

      if (!this.dndUppyClient) {
        this.dndUppyClient = UppyClient(options);
      }

      this.removeDropPane(); // make sure there is only one DropTarget plugin.

      this.dndUppyClient.use(DropTarget, {
        target: target,
        onDragOver: onDragOver,
        onDrop: onDrop,
        onDragLeave: onDragLeave
      });
    }
  }, {
    key: "removeDropPane",
    value: function removeDropPane() {
      if (this.dndUppyClient) {
        var dropTargetPlugin = this.dndUppyClient.getPlugin('DropTarget');

        if (dropTargetPlugin) {
          this.dndUppyClient.removePlugin(dropTargetPlugin);
        }
      }
    }
  }]);

  return KjUploader;
}();

function _componentProps2() {
  return _objectSpread(_objectSpread({}, this.config), {}, {
    logger: this.logger,
    unmountReact: this.close.bind(this)
  });
}

function _mountNode2() {
  return document.getElementById(MOUNT_NODE_ID) || _classPrivateFieldLooseBase(this, _createMountNode)[_createMountNode]();
}

function _createMountNode2() {
  var el = document.createElement('div');
  el.setAttribute('id', MOUNT_NODE_ID);
  return this.config.parentNode.appendChild(el);
}

function _mountImageEditorModal2(_ref2) {
  var _this$config$onOpen2, _this$config3;

  var uppy = _ref2.uppy,
      file = _ref2.file,
      options = _ref2.options;
  ReactDomAdapter.render( /*#__PURE__*/React.createElement(ImageEditorModal, Object.assign({}, options, {
    uppy: uppy,
    fileId: file.id,
    modalTitle: "Edit image"
  })), _classPrivateFieldLooseBase(this, _mountNode)[_mountNode]());
  this.logger.debug('open image editor');
  (_this$config$onOpen2 = (_this$config3 = this.config).onOpen) === null || _this$config$onOpen2 === void 0 ? void 0 : _this$config$onOpen2.call(_this$config3);
}

export default KjUploader;